import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://capitalchauffeurservices.com';
const OG_IMAGE = 'https://customer-assets.emergentagent.com/job_31dc5cc9-4948-412e-afd9-88900b02bc09/artifacts/pxgayyb3_4.jpg';

export const SEOHead = ({ 
  title, 
  description, 
  canonical, 
  ogType = 'website',
  schema 
}) => {
  const fullUrl = `${SITE_URL}${canonical}`;
  
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={fullUrl} />
      
      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content={ogType} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content="Capital Chauffeur Services" />
      <meta property="og:locale" content="en_US" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={OG_IMAGE} />
      
      {/* Schema.org JSON-LD */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
};
